import './App.css';
import React from 'react';
import ProcessingProvider from './contexts/processing';
import UserProvider from './contexts/user';
import ToggleProvider from './contexts/toggle';
import Widget from './components/widget/widget';
import useConfig from './hooks/config.hook';
import PushNotificationProvider from './contexts/push-notification';
import LanguageProvider from './contexts/language';

function App() {
  if (!useDisplay()) return null;
  return (
    <ProcessingProvider>
      <UserProvider>
        <PushNotificationProvider>
          <LanguageProvider>
            <ToggleProvider>
              <Widget />
            </ToggleProvider>
          </LanguageProvider>
        </PushNotificationProvider>
      </UserProvider>
    </ProcessingProvider>
  );
}

function useDisplay() {
  let config = useConfig();
  return config?.visible
}

export default App;
